<script>
export default {
	props: ['description'],
	template: '<li class="sky-swiper-item"><slot /></li>',
	created() {
		this.$parent.slides.push({
			id: this._uid,
			description: this.description,
		});
	},
};
</script>



// WEBPACK FOOTER //
// sky-swiper-item.vue?0a9d45fd